// extracted by mini-css-extract-plugin
module.exports = {"box-card":"examCard_box-card_Own6U","img":"examCard_img_BD2I8","txt-item":"examCard_txt-item_1oZRO","type":"examCard_type_1nNH6","in-btn":"examCard_in-btn_fQyDl"};